import React from 'react';

const SvgPy = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="PY_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="PY_svg__b" fill="#fff">
        <use xlinkHref="#PY_svg__a" />
      </mask>
      <rect
        stroke="#F5F5F5"
        strokeWidth={0.5}
        x={0.25}
        y={0.25}
        width={27.5}
        height={19.5}
        rx={2}
      />
      <path fill="#E33F39" mask="url(#PY_svg__b)" d="M0 0h28v6.667H0z" />
      <path fill="#124BBA" mask="url(#PY_svg__b)" d="M0 13.333h28V20H0z" />
      <circle
        stroke="#398153"
        strokeWidth={0.667}
        mask="url(#PY_svg__b)"
        cx={14}
        cy={10}
        r={2.333}
      />
      <circle fill="#E5CF58" mask="url(#PY_svg__b)" cx={14} cy={10} r={1} />
    </g>
  </svg>
);

export default SvgPy;
